import { useSEO, generateWebPageSchema, generateBreadcrumbSchema, generateServiceSchema } from '@/utils/seo';
import ServicePageLayout, { ServicePageConfig } from '@/pages/service-common/ServicePageLayout';

/* ─── Hero Background ─── */
const HERO_IMG = 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20golden%20film%20reel%20and%20video%20play%20button%20with%20light%20rays%20on%20deep%20navy%20blue%20background%20minimal%20sophisticated%20high-end%20corporate%20aesthetic%20soft%20glowing%20particles%20no%20text&width=1920&height=800&seq=videohero1&orientation=landscape';

const config: ServicePageConfig = {
  pageLabel: '動画・ブランディング制作',
  heroImage: HERO_IMG,
  tag: 'Video & Branding',
  title: <>440本の動画制作実績が<br />証明する映像の力</>,
  subtitle: '440本以上の動画制作実績。ブランドフィルムからSNSショート動画まで、ビジュアルストーリーテリングでブランドの世界観を強力に表現します。',
  icon: 'ri-movie-2-line',
  services: [
    { icon: 'ri-film-line', title: 'ブランドフィルム', desc: 'ブランドの本質を伝えるシネマティックな映像作品を制作します。' },
    { icon: 'ri-gift-line', title: '商品・サービス動画', desc: '商品やサービスの魅力を最大限に引き出す、説得力のある動画を制作します。' },
    { icon: 'ri-question-answer-line', title: 'explainer動画', desc: '複雑なコンセプトやサービスを分かりやすく伝えるアニメーション動画を制作します。' },
    { icon: 'ri-vidicon-line', title: 'SNS向け動画コンテンツ', desc: 'InstagramやTikTokなど各プラットフォーム最適化された短尺コンテンツを制作します。' },
    { icon: 'ri-presentation-line', title: 'コーポレート・採用動画', desc: '会社の魅力と文化を伝える、採用強化に直結するコーポレート動画を制作します。' },
    { icon: 'ri-calendar-event-line', title: 'イベント撮影・記録', desc: '企業イベントや展示会などの重要な場面を、印象的な映像として記録します。' },
  ],
  steps: [
    { title: 'コンセプト設計', desc: 'ブランドのストーリーとクリエイティブ方向性を定義します。' },
    { title: 'プリプロダクション', desc: '脚本・絵コンテ作成と撮影・制作の詳細計画を立案します。' },
    { title: 'プロダクション', desc: 'プロ機材と熟練スタッフによる高品質な撮影・収録を実施します。' },
    { title: 'ポストプロダクション', desc: '編集・カラーグレーディング・サウンドデザインで映像を磨き上げます。' },
    { title: '納品・配信最適化', desc: '各プラットフォームに最適化された形式で納品・配信をサポートします。' },
  ],
  stats: [
    { number: '440+', label: '動画制作本数' },
    { number: '15M+', label: '累計再生数' },
    { number: '4.8', label: 'クライアント評価（5点満点）' },
    { number: '3x', label: 'エンゲージメント向上率' },
  ],
  benefits: [
    '440本以上の制作実績で培った、業種・目的別の映像制作ノウハウ',
    'ブランドの世界観を映像で体現し、視聴者の感情に深く訴えかける',
    '動画コンテンツによるブランド認知度と記憶への定着を大幅に向上',
    'SNS最適化された動画コンテンツでエンゲージメントと拡散力を向上',
    '企画から配信まで一貫したサポートでスムーズなプロジェクト進行を実現',
    '映像とブランディングの両輪で、一貫したブランドアイデンティティを構築',
  ],
};

export default function VideoBrandingPage() {
  useSEO({
    title: '東京 動画・ブランディング制作 TradFit株式会社 | 440本の制作実績',
    description: 'TradFit株式会社の動画・ブランディング制作サービス。440本以上の動画制作実績。ブランドフィルムからSNSショート動画まで対応します。',
    keywords: '動画制作, ブランディング, ブランドフィルム, SNS動画, コーポレート動画, 東京',
    path: '/video-branding',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateWebPageSchema('動画・ブランディング制作 | TradFit株式会社', 'TradFit株式会社の動画・ブランディング制作サービス。', '/video-branding'),
        generateBreadcrumbSchema([{ name: 'ホーム', path: '/' }, { name: '事業内容', path: '/business' }, { name: '動画・ブランディング制作', path: '/video-branding' }]),
        generateServiceSchema('動画・ブランディング制作', 'ブランドフィルムからSNSショート動画までの動画・ブランディング制作サービス。'),
      ],
    },
  });
  return <ServicePageLayout config={config} />;
}
